import { render, staticRenderFns } from "./NewDataNote.vue?vue&type=template&id=7f939eee&scoped=true&"
import script from "./NewDataNote.vue?vue&type=script&lang=js&"
export * from "./NewDataNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f939eee",
  null
  
)

export default component.exports